import { ref } from 'vue';

const authToken = ref(localStorage.getItem('authToken') || null);

export function useAuthToken() {
	const setAuthToken = (token) => {
		authToken.value = token;
		if (token) {
			localStorage.setItem('authToken', token);
		} else {
			localStorage.removeItem('authToken');
		}
	};

	const getAuthToken = () => {
		return authToken.value;
	};

	const clearAuthToken = () => {
		authToken.value = null;
		localStorage.removeItem('authToken');
	};

	// Watch for changes and keep localStorage in sync
	// watch(authToken, (newToken) => {
	// 	if (newToken) {
	// 		localStorage.setItem('authToken', newToken);
	// 	} else {
	// 		localStorage.removeItem('authToken');
	// 	}
	// });

	return {
		authToken,
		setAuthToken,
		getAuthToken,
		clearAuthToken,
	};
}